const Imprint = () => import(/* webpackChunkName: "Imprint" */ '@/assets/js/src/modules/imprint/_views/Imprint.vue')

export default [
    {name: 'Imprint', path: '/imprint', meta: {uiType: 'Overlay',}, component: Imprint,},
]